import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { stopPropagation } from '../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'

import { QA_NAME_CONNECT_SERVICE_REQUESTS } from './NewsboardPostProfileWidgetServiceRequestsEditButton.constants'

import EditIcon from '../../../../icons/edit.svg'

function NewsboardPostProfileWidgetServiceRequestsEditButton({
  onClick,
  ...restProps
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)
    onClick?.(event)
  }

  return (
    <Button.Outlined
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: EditIcon }}
      height={BUTTON_HEIGHT_32}
      qaName={QA_NAME_CONNECT_SERVICE_REQUESTS}
      tooltip={t('Newsboard.ConnectRequestActionOptionKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default NewsboardPostProfileWidgetServiceRequestsEditButton
